import React, { useCallback } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { components, type OptionType, type MenuListComponentProps } from '@atlaskit/select';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { MenuListPropsType } from '../../../common/types.tsx';
import ErrorMessage from './error-message/index.tsx';
import LoadingMessage from './loading-message/index.tsx';
import LoadMoreTrigger from './load-more-trigger/index.tsx';

type CustomProps = {
	selectProps: {
		menuListProps: MenuListPropsType;
	};
};

export const MenuList = (props: MenuListComponentProps<OptionType> & CustomProps) => {
	const {
		selectProps: {
			menuListProps: {
				error: { isError, onRetry },
				handleShowMore,
				isLoading,
				isPaginationLoading,
				isShowMoreEnabled,
			},
		},
	} = props;
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleOnShowMore = useCallback(() => {
		fireUIAnalytics(
			createAnalyticsEvent({
				actionSubject: 'options',
				action: 'scrolled',
			}),
			'filterSearchShowMore',
		);

		handleShowMore();
	}, [handleShowMore, createAnalyticsEvent]);

	return (
		<>
			<components.MenuList {...props}>
				{isLoading && <LoadingMessage />}
				{!isLoading && isError && <ErrorMessage onRetry={onRetry} />}
				{!isLoading && !isError && (
					<>
						{props.children}
						{isShowMoreEnabled && (
							<LoadMoreTrigger
								onShowMore={handleOnShowMore}
								isPaginationLoading={isPaginationLoading}
							/>
						)}
					</>
				)}
			</components.MenuList>
		</>
	);
};

export default MenuList;
